<template>
  <sui-modal class="wrapper" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Move container
    </sui-modal-header>
    <sui-modal-content :scrolling="!!entity">
      <sui-form :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <h3 class="ui header">Container</h3>
        <sui-form-field>
          <sui-dropdown selection v-model="containerId" direction="downward" :options="containersList" placeholder="Select container..." />
        </sui-form-field>
        <FormContainer v-model="entity" :mode="mode" v-if="entity" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="loading || hasEntityErrors" @click="submit()">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Moving started
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import FormContainer from '@/components/forms/Container'
  import ModalForm from '@/mixins/ModalForm'
  import utils from '@/utils'

  export default {
    name: 'ModalMoveContainer',
    mixins: [
      ModalForm,
    ],
    components: {
      FormContainer,
    },
    data() {
      return {
        containerId: null,
        entity: null,
      }
    },
    computed: {
      ...mapGetters(['containers', 'containersById']),
      container() {
        return this.containersById[this.containerId]
      },
      mode() {
        return 'moving'
      },
      service() {
        return this.entity ? this.entity._service : null
      },
      containersList() {
        return this.containers.map(container => {
          return {
            image: {src: container._service._logo},
            value: container.id,
            text: container.name,
          }
        })
      },
    },
    watch: {
      containerId() {
        this.entity = null
        this.$nextTick(() => {
          this.entity = {
            ...this.container,
            hosts: [],
          }
        })
      },
    },
    methods: {
      open(entity = {}) {
        this.visible = true
        this.containerId = entity.id
      },
      reset() {
        this.apiErrors = null
        this.success = false
        this.entity = null
        this.containerId = null
      },
      submit() {
        this.apiErrors = null
        this.loading = true
        utils.reachGoal('MOVE_CONTAINER_TRY')
        return this.entity.move(this.entity.hosts[0].id).then(() => {
          utils.reachGoal('MOVE_CONTAINER_SUCCESS')
          this.success = true
          setTimeout(() => {
            this.close()
          }, 1000)
        }).catch(error => {
          utils.reachGoal('MOVE_CONTAINER_FAIL')
          this.apiErrors = error
        }).finally(() => {
          this.loading = false
        })
      },
    },
    created() {
      this.$modals.moveContainer = this
    },
  }
</script>
